export enum TimeIntervalsEnum {
  MINUTE = '1m',
  HOUR = '1h',
  DAY = '1d',
  MONTH = '1M',
}
export interface ISingleChartSetting {
  byTime: boolean
  grow: boolean
}
export interface IChartTypesState {
  count: ISingleChartSetting
  date: ISingleChartSetting
  fullVolume: ISingleChartSetting
  pureProfit: ISingleChartSetting
  fee: ISingleChartSetting
  missIndex: ISingleChartSetting
  profit: ISingleChartSetting
  volumeToAction: ISingleChartSetting
  feeToPureProfit: ISingleChartSetting
  volumeToPureProfit: ISingleChartSetting
  expectedProfit: ISingleChartSetting
  expectedProfitPercent: ISingleChartSetting
  avgTimeBetweenOrders: ISingleChartSetting
}
export interface IInvestors{
  investors: {
    _id: {
      createdAt: number
      name: string
      fee: number
      token_balance: number
    }
    pureProfit: number
  }[]
}